import { getCellIds } from "./../helpers/main";
import { IAction, IActionConfig } from "./../types";
import { actions } from "./ActionsManager";

export class GroupRowAction implements IAction {
	public config: IActionConfig;
	private _actions: IAction[];

	constructor(config: IActionConfig) {
		this.config = config;
		this._actions = [];
	}

	do() {
		const { cell, grid, spreadsheet } = this.config;
		if (!this._actions.length) {
			const id = getCellIds(cell, grid);
			const startCol = id.start.col;
			const firstCell = cell.split(":")[0];

			spreadsheet.eachCell(cell => {
				const { row, col } = getCellIds(cell, grid);
				if (col === startCol) {
					const action = new (actions[this.config.action] as any)({
						...this.config,
						row,
						col,
						cell: firstCell,
					});
					this._actions.push(action);
				}
			}, this.config.cell);
		}

		for (let i = this._actions.length - 1; i >= 0; i--) {
			this._actions[i].do();
		}
	}

	undo() {
		for (let i = this._actions.length - 1; i >= 0; i--) {
			this._actions[i].undo();
		}
	}
}
